import Store from "App/Store.js";

export default () => Store.dispatch({type: "checkoutBasket", checkoutBasket: []});
